import React, {useEffect, useState, useRef} from "react";
import "./style.scss";

import UserIcon from "../../../assets/icons/user.svg";
import PhoneIcon from "../../../assets/icons/phone.svg";
import WebIcon from "../../../assets/icons/web.svg";
import EmailIcon from "../../../assets/icons/email.svg";
import LockIcon from "../../../assets/icons/lock.svg";
import EyeIcon from "../../../assets/icons/eye.svg";
import EyeSlashedIcon from "../../../assets/icons/eye-slashed.svg";
import CheckSolidGreenIcon from "../../../assets/icons/check-solid-green.svg";
import ArrowRightIcon from "../../../assets/icons/arrow-right.svg";
import CaretDownIcon from "../../../assets/icons/caret-down.svg";
import GoogleIcon from "../../../assets/icons/googleIcon.svg";

import {Link, useNavigate, useParams} from "react-router-dom";
import {validateContact, validateEmail, validateLetters, validatePassword} from "../../../utils/helpers/string";
import {country} from "../../../utils/constants/country";
import Tooltip from "../../../reusableComponents/Tooltip";
import {signupRequest} from "../../../utils/apis";
import {useDispatch} from "react-redux";
import {authenticate, setAuthenticationStatus, setAuthenticationSuccess} from "../../../store/reducers/authSlice";
import ErrorModal from "../../../reusableComponents/ErrorModal";
import {returnErrors} from "../../../store/reducers/error";
import Spinner from "../../../reusableComponents/Spinner";
import {pushLeads} from "../../../utils/apis/auth";
import CompanyLogo from "../../../assets/icons/equityEdgeLogo.svg";
import * as Yup from "yup";
import {useFormik} from "formik";
import customStyles from "../../../customstyle/customstyle";
import {Checkbox, FormControlLabel} from "@mui/material";

function SignupForm({referalcode}) {
  // const {referalcode} = useParams();

  const countryRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isDropdown, setIsDropdown] = useState(false);
  const [countryCode, setCountryCode] = useState("44");
  // removed log

  const countryOptions = country;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [options, setOptions] = useState(countryOptions);
  const [formData, setFormData] = useState(new FormData());
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isSpinner, setIsSpinner] = useState(false);
  const countryNames = country.map((country) => country.country.toLowerCase());

  const schema = Yup.object().shape({
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    city: Yup.string().required("City is required"),
    country: Yup.string()
      .test("is-valid-country", "Invalid country name.", (value) => countryNames.includes(value.toLowerCase()))
      .required("Country is required"),
    contact: Yup.number().required("Number is required"),
    email: Yup.string()
      .email("Invalid email format")
      .matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email format, please provide a valid email")
      .required("Email is required"),
    confirm_email: Yup.string()
      .oneOf([Yup.ref("email"), null], "Emails must match")
      .required("Please confirm your email"),

    password: Yup.string().required("Password is required").min(8, "Password must be at least 8 characters long").max(16, "Password must not exceed 16 characters"),

    country_code: Yup.string()
      .oneOf(
        country.map((item) => item.code),
        "Invalid country code",
      )
      .required("Country code is required"),
    marketing_emails: Yup.boolean(),
  });

  const inputs = {
    first_name: "",
    last_name: "",
    city: "",
    country: "",
    contact: "",
    email: "",
    confirm_email: "", // Added confirm_email to initial values
    password: "",
    country_code: countryCode,
    marketing_emails: false,
    ...(referalcode && {referal_code: referalcode}),
  };

  const {values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue} = useFormik({
    initialValues: inputs,
    validationSchema: schema,
    onSubmit: async (values) => {
      console.log("inputs", values);

      setIsSpinner(true);
      const formData = new FormData();
      // Exclude confirm_email from the data sent to backend
      Object.keys(values).forEach((key) => {
        if (key !== "confirm_email") {
          formData.append(key, values[key]);
        }
      });

      if (serachInput === "Ethiopia") {
        let mes = "Ethiopia is a restricted country. New sign-ups and purchases are not permitted.";
        dispatch(returnErrors(mes, 400));
        setIsSpinner(false);
        return;
      }

      const response = await signupRequest(formData);

      if (response.status <= 201) {
        // dispatch(authenticate({email: values.email, password: values.password}));
        dispatch(setAuthenticationSuccess({data: {idToken: response.data.idToken}}));
        navigate("/funding-evaluation/plans/0");
        setIsSpinner(false);
      } else if (response.response) {
        let msg = "";
        setIsSpinner(false);

        if (response?.response?.data) {
          msg = response?.response?.data?.detail || response?.response?.data?.email[0];
          setIsSpinner(false);
        } else {
          msg = "Please check all the field";
        }
        dispatch(returnErrors(msg, 400));
        setIsSpinner(false);
      }
    },
  });

  useEffect(() => {
    if (referalcode) {
      formData.set("referal_code", referalcode);
      let formDataPL = new FormData();
      formDataPL.append("referal_code", referalcode);
      pushLeads(formDataPL);
    }
  }, []);

  const handleDropdownChange = (value) => {
    const selectedOption = options.find((option) => option === value);
    if (selectedOption) {
      setFieldValue("country", value.country);
      setFieldValue("country_code", value.code);
      setCountryCode(value.code);
      setSearchInput(value.country);
      setIsDropdown(false);
    }
  };

  const [serachInput, setSearchInput] = useState("United Kingdom");
  useEffect(() => {
    setFieldValue("country_code", countryCode);
    setFieldValue("country", serachInput);
  }, [countryCode, serachInput]);
  const handleSearch = (e) => {
    setIsDropdown(true);

    const {name, id, value} = e.target;
    id === "country" && setOptions(countryOptions.filter((item) => item.country.toLowerCase().includes(value.toLowerCase())));
    setSearchInput(value);
  };
  const countryMainRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (countryRef.current && !countryRef.current.contains(event.target) && countryMainRef.current && !countryMainRef.current.contains(event.target)) {
        setIsDropdown(false);
      }
    };

    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleGoogleAuth = (e) => {
    e.preventDefault();
    let path =
      "https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/user.phonenumbers.read https://www.googleapis.com/auth/user.addresses.read&include_granted_scopes=true&response_type=code&state=pass-through value&redirect_uri=https://app.equityedge.io/auth/google&client_id=454348839117-icvli9lq10npbbautre2h62keggrvnlp.apps.googleusercontent.com";
    window.location.replace(path);
  };

  console.log("first_name", serachInput);

  return (
    <div className="signupform-container">
      <div className="signupform-subcontainer">
        <form
          className="signupform-innercontainer signupformContainer_form"
          onSubmit={handleSubmit}
        >
          <div className="leftSideForm">
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>Email</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="email"
                  ></label>
                  <input
                    type="text"
                    name="email"
                    id="email"
                    className="signupform-input inputDiv"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Email Address"
                  />
                </div>

                <div className="signupform-container_icon">
                  {validateEmail(values.email) && (
                    <img
                      src={CheckSolidGreenIcon}
                      alt=""
                      className="signupform-icon"
                    />
                  )}
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>{touched.email && errors.email && <div className="error-message">{errors.email}</div>}</div>
            </div>
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>Confirm Email</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="confirm_email"
                  ></label>
                  <input
                    type="text"
                    name="confirm_email"
                    id="confirm_email"
                    className="signupform-input inputDiv"
                    value={values.confirm_email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Confirm Email Address"
                  />
                </div>

                <div className="signupform-container_icon">
                  {validateEmail(values.confirm_email) && values.confirm_email === values.email && (
                    <img
                      src={CheckSolidGreenIcon}
                      alt=""
                      className="signupform-icon"
                    />
                  )}
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>
                {touched.confirm_email && errors.confirm_email && <div className="error-message">{errors.confirm_email}</div>}
              </div>
            </div>
            {/*----------------------email*/}
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>Name</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="first_name"
                  ></label>
                  <input
                    type="text"
                    name="first_name"
                    id="first_name"
                    placeholder="First Name"
                    className="signupform-input inputDiv"
                    value={values.first_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>
                {touched.first_name && errors.first_name && <div className="error-message">{errors.first_name}</div>}
              </div>
            </div>{" "}
            {/*----------------------Name*/}
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>Last Name</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="last_name"
                  ></label>
                  <input
                    type="text"
                    name="last_name"
                    id="last_name"
                    className="signupform-input inputDiv"
                    value={values.last_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Last Name"
                  />
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>{touched.last_name && errors.last_name && <div className="error-message">{errors.last_name}</div>}</div>
            </div>
            {/*----------------------LastName*/}
          </div>

          <div className="rightSideForm">
            <div className="signupform-container_dropdown">
              {/* <label
              className="signupform-label"
              htmlFor="email"
            >
              Country
            </label> */}
              <div
                ref={countryRef}
                className="signupform-subcontainer_form"
                onClick={() => setIsDropdown(true)}
              >
                <div
                  className={`signupform-innercontainer_form ${isDropdown ? "signupform-select" : ""}`}
                  ref={countryMainRef}
                >
                  <h3>Country</h3>
                  <div className="signupform-container_input">
                    <input
                      type="text"
                      name="country"
                      id="country"
                      className="signupform-input inputDiv"
                      value={serachInput}
                      onChange={handleSearch}
                      onBlur={handleBlur}
                      styles={customStyles}
                    />
                    {/* <p className="signupform-input">{inputValue.country}</p> */}
                  </div>

                  <div className="signupform-container_icon">
                    <img
                      src={CaretDownIcon}
                      alt=""
                      className="signupform-icon"
                    />
                  </div>
                </div>
                <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>
                  {" "}
                  {touched.country && errors.country && (
                    <div
                      className="error-message"
                      style={{zIndex: isDropdown && "10"}}
                    >
                      {errors.country}
                    </div>
                  )}
                </div>
              </div>

              {/* <Tooltip isActive={isInputError.country}>{inputError.country}</Tooltip> */}
              {isDropdown && (
                <div
                  id="signupform-dropdown"
                  className="signupform-dropdown signupform-innercontainer_form"
                >
                  <ul>
                    {options.length !== 0 ? (
                      options.map((item, index) => (
                        <li
                          key={index}
                          className={`${serachInput === item.country ? "signupform-dropdown_active" : ""}`}
                          onClick={() => handleDropdownChange(item)}
                        >
                          {item.country}
                        </li>
                      ))
                    ) : (
                      <li className="list-no_country">No Country</li>
                    )}
                  </ul>
                </div>
              )}
            </div>{" "}
            {/*----------------------country*/}
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>City</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="city"
                  ></label>
                  <input
                    type="text"
                    name="city"
                    id="city"
                    className="signupform-input inputDiv"
                    value={values.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="City"
                  />
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>{touched.city && errors.city && <div className="error-message">{errors.city}</div>}</div>
            </div>
            {/*----------------------City*/}
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form contactDivWrapper">
                <h3>Phone number</h3>
                <div
                  className="signupform-container_input contactDiv "
                  style={{flexDirection: "row"}}
                >
                  <div>
                    <span
                      className="contactCode"
                      style={{
                        display: "flex",
                        color: "#f3c967",
                        // borderRight: "1px solid #242529",
                        // marginRight: "7px",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="text"
                        value={values.country_code}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (/^-?\d*-?\d*$/.test(inputValue)) {
                            setFieldValue("country_code", inputValue);
                          }
                        }}
                        style={{width: "50px", fontSize: "16px", color: ""}}
                      />
                    </span>
                  </div>
                  <input
                    type="number"
                    name="contact"
                    id="contact"
                    className="signupform-input contactInputNumber"
                    placeholder="Contact Number"
                    value={values.contact}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    style={{width: "100%"}}
                  />
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>{touched.contact && errors.contact && <div className="error-message">{errors.contact}</div>}</div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>
                {touched.country_code && errors.country_code && <div className="error-message">{errors.country_code}</div>}
              </div>
            </div>
            {/*----------------------contactNumber*/}
            <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>Password</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="password"
                  ></label>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    id="password"
                    className="signupform-input inputDiv"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Password"
                  />
                </div>

                <div className="signupform-container_icon">
                  <img
                    src={isPasswordVisible ? EyeIcon : EyeSlashedIcon}
                    alt=""
                    className="signupform-icon"
                    onClick={() => setIsPasswordVisible((prev) => !prev)}
                  />
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px", marginTop: "5px"}}>{touched.password && errors.password && <div className="error-message">{errors.password}</div>}</div>
            </div>
            {/*--------------password*/}
          </div>

          {/* <div className="signupform-subcontainer_form">
              <div className="signupform-innercontainer_form">
                <h3>Re-Enter Password</h3>
                <div className="signupform-container_input">
                  <label
                    className="signupform-label"
                    htmlFor="password"
                  ></label>
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    id="password"
                    className="signupform-input inputDiv"
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Password"
                  />
                </div>

                <div className="signupform-container_icon">
                  <img
                    src={isPasswordVisible ? EyeIcon : EyeSlashedIcon}
                    alt=""
                    className="signupform-icon"
                    onClick={() => setIsPasswordVisible((prev) => !prev)}
                  />
                </div>
              </div>
              <div style={{display: "flex", color: "red", fontSize: "15px"}}>{touched.password && errors.password && <div className="error-message">{errors.password}</div>}</div>
            </div> */}
          {/* New Email Confirmation Field */}
          {/* <div className="signupform-subcontainer_form">
            <div className="signupform-innercontainer_form">
              <div className="signupform-container_input">
                <label
                  className="signupform-label"
                  htmlFor="confirm_email"
                ></label>
                <input
                  type="text"
                  name="confirm_email"
                  id="confirm_email"
                  className="signupform-input"
                  value={values.confirm_email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  onCopy={(e) => e.preventDefault()}
                  onPaste={(e) => e.preventDefault()}
                  onCut={(e) => e.preventDefault()}
                  placeholder="Confirm Email Address"
                />
              </div>

              <div className="signupform-container_icon">
                Optionally, add a check icon or any other indicator for confirmation
                {values.confirm_email && values.confirm_email === values.email && (
                  <img
                    src={CheckSolidGreenIcon}
                    alt=""
                    className="signupform-icon"
                  />
                )}
              </div>
            </div>
            <div style={{display: "flex", color: "red", fontSize: "15px"}}>{touched.confirm_email && errors.confirm_email && <div className="error-message">{errors.confirm_email}</div>}</div>
          </div> */}
          {/* End of Email Confirmation Field */}

          {/* <p className="signupform-error">The password entered is wrong!</p> */}
        </form>

        <div className="signupform-subcontainer_form marketing-emails-consent">
          <FormControlLabel
            control={
              <Checkbox
                name="marketing_emails"
                checked={values.marketing_emails}
                onChange={(e) => setFieldValue("marketing_emails", e.target.checked)}
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "#36D66B",
                    borderRadius: "4px",
                  },
                }}
              />
            }
            label='I agree to receive marketing emails, updates, and offers from Equity Edge Ltd.'
          />
        </div>

        {/* <h2 className="signupform-title">Sign up</h2> */}
        {/* 
        <p className="signupform-continue">with</p> */}
        {/* <div className="signinform-innercontainer signinform-container_icon">
          <div className="signinform-subcontainer_icon">
            <img
              src={GoogleIcon}
              alt=""
              className="signinform-icon"
              onClick={handleGoogleAuth}
            />
          </div>
        </div> */}
      </div>
      <div className="signupform-link">
        Already have an account?{" "}
        <Link to="/signin">
          <b className="signupform-link_bold">Sign In</b>
        </Link>
      </div>

      <div className="submit_button_container">
        <button
          className="submit_button"
          onClick={handleSubmit}
          // disabled={isLoading}
        >
          {isSpinner ? <Spinner /> : <>Submit</>}
        </button>
      </div>
      <div className="optionSection">
        <div className="line"></div>
        <div className="Option">
          <p>Or</p>
        </div>
        <div className="line"></div>
      </div>
      <div
        className="signinform-link"
        onClick={handleGoogleAuth}
      >
        {/* Don&#39;t have an account?{" "}
            <Link to="/signup">
              <b className="signinform-link_bold">Sign Up</b>
            </Link> */}
        <div className="icon">
          <img
            src={GoogleIcon}
            alt=""
          />
        </div>
        <div className="signup">
          <p>Sign up with Google</p>
        </div>
      </div>
    </div>
  );
}

export default SignupForm;
